export default {
  state: {
    cisbaCategoryData: {},
    cisbaCategoryModalType: "CREATE",
    cisbaCategoryModalStatus: false,
  },

  getters: {
    getCisbaCategoryData(state) {
      return state.cisbaCategoryData;
    },
  },

  mutations: {
    setCisbaCategoryModalInfos(state, infos) {
      const isNull = infos === null;

      state.cisbaCategoryData = {
        id: !isNull ? infos.id : "",
        name: !isNull ? infos.name : "",
        description: !isNull ? infos.description : "",
        position: !isNull ? infos.position : null,
        color: !isNull ? infos.color : "#FFFFFFFF",
        file: !isNull ? infos.file : null,
        cisba_sub_categories: !isNull ? infos.cisba_sub_categories : [],
      };
    },

    setCisbaCategoryModalStatus(state, data) {
      state.cisbaCategoryModalStatus = data;
    },
  },

  actions: {
    changeCisbaCategoryModalInfos(context, infos) {
      context.commit("setCisbaCategoryModalInfos", infos);
    },
  },
};
